export default function initializePlanAccordion() {
  document.querySelectorAll('.jsPlanAccordion').forEach(button => {
    button.addEventListener('click', (e) => {
      // 「詳細をみる」リンクがクリックされた場合はアコーディオンを操作しない
      if (e.target.closest('.jsAccordionDetailLink')) {
        return;
      }

      e.preventDefault();
      const section = button.closest('.jsPlanSection');
      const body = section.querySelector('.jsAccordionBody');

      if (body.style.display === 'none') {
        body.style.display = 'block';
        button.classList.add('open');
      } else {
        body.style.display = 'none';
        button.classList.remove('open');
      }
    });
  });
}
